import React from 'react';
import { howItWorks } from '../data/introContent';
export function HowItWorks() {
  return <section aria-labelledby="how-it-works-heading" className="mx-auto w-full max-w-reading rounded-xl border border-border bg-cream-light p-7 text-left sm:p-8" data-id="element-14" data-mp="7tenf9brlex2">
      <h2 id="how-it-works-heading" className="font-display text-[15px] font-semibold text-ink" data-id="element-15" data-mp="3u03i9fzd5zp3">
        How it works
      </h2>
      <ul className="mt-4 space-y-2.5" data-id="element-16" data-mp="lk09t80fg6zp">
        {howItWorks.map(step => <li key={step} className="flex gap-3 text-[14px] leading-relaxed text-ink-light" data-id="element-17" data-mp="qj3dao0re55k">
            <span aria-hidden="true" className="text-harbor" data-id="element-18" data-mp="crydnlxe5cv8">
              →
            </span>
            <span data-id="element-19" data-mp="gtjufid1qbap">{step}</span>
          </li>)}
      </ul>
    </section>;
}